import { State } from '@/store/store'
export interface CenterList {
  column: Array<{
    text: string
    value: string
    type?: string
    options?: {
      orderable?: boolean
      lengthLimit?: number
      filter?: boolean
      operation: string[],
    },
  }>
  defaultFilter: object
  itemCount: number
  page: number
  pageCount: number
  result: ICenter[]
}

export class CenterState {
  public list: CenterList
  constructor() {
    this.list = {
      column: [],
      itemCount: 0,
      page: 1,
      pageCount: 1,
      result: [],
      defaultFilter: {},
    }
  }
}

export interface ICenter {
  _id: string,
  name: string,
  map: {
    lat: number,
    lon: number,
  },
  address: {
    address: string,
    country?: string,
    district?: string,
    elevation?: number,
    geocode?: string,
    postcode?: string,
    province?: string,
    road?: string,
    road_lat?: number,
    road_lon?: number,
    subdistrict?: string,
  },
  createdAt?: number
  updatedAt?: number
}

export default CenterState
